(function () {
  'use strict';

  /* @ngdoc object
   * @name pairingCompliments
   * @description
   *
   */
  angular
    .module('pairingCompliments', [
      'ui.router'
    ]);
}());
